import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicCircleDirectLetUnselected({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 56 56"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <circle cx={28} cy={28} r={28} fill="#999" />
      <path
        d="M16.5 17.8a1 1 0 011-1h21a1 1 0 011 1v11a1 1 0 01-1 1h-21a1 1 0 01-1-1v-11z"
        fill="#fff"
      />
      <path
        d="M15.56 31.82a1 1 0 01.92-.62h22.87a1 1 0 01.91.6l2.93 6.7a.5.5 0 01-.45.7h-29.5a.5.5 0 01-.45-.7l2.77-6.68z"
        fill="#CCC"
      />
    </svg>
  );
}

SvgPicCircleDirectLetUnselected.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicCircleDirectLetUnselected.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicCircleDirectLetUnselected svgRef={ref} {...props} />
));
export default ForwardRef;
